/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type TermsAndConditionsType = typeof TermsAndConditionsType[keyof typeof TermsAndConditionsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermsAndConditionsType = {
  GENERAL_SERVICE: 'GENERAL_SERVICE',
  SELF_REGISTRATION: 'SELF_REGISTRATION',
  LOAN_GENERAL: 'LOAN_GENERAL',
  LOAN_PRODUCT_SPECIFIC: 'LOAN_PRODUCT_SPECIFIC',
  SAVINGS_ACCOUNT: 'SAVINGS_ACCOUNT',
  MEMBERSHIP: 'MEMBERSHIP',
} as const;
